import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { colors } from "@material-ui/core";

const InstructionModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const InstructionRow = ({ setConfigModalOpen, existingConfig }) => {
  const destExists = existingConfig.id !== undefined;
  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={destExists ? "" : colors.red[600]}
      labelText={destExists ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const INSTRUCTION = "INSTRUCTION";

const Rows = {
  INSTRUCTION: InstructionRow,
};

const Modals = {
  INSTRUCTION: InstructionModal,
};

const RowOrder = [INSTRUCTION];

export default {
  Rows,
  RowOrder,
  Modals,
};
